export default __webpack_public_path__ + "static/media/ISMS_certified.c5695451.svg";